import { render, staticRenderFns } from "./RelevantInformationTable.vue?vue&type=template&id=3e8770d8&scoped=true&"
import script from "./RelevantInformationTable.vue?vue&type=script&lang=js&"
export * from "./RelevantInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./RelevantInformationTable.vue?vue&type=style&index=0&id=3e8770d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8770d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
